import { AddExistingGuests } from '@common/components';
import { SectionWrapper } from '@common/components/BookingForms';
import { FC } from 'react';
import { InjectedFormProps, WrappedFieldArrayProps } from 'redux-form';
import { GuestDetails } from './GuestDetails';
import { GuestDetailsAndSelectionsPropsConnectedType } from './GuestDetailsAndSelections.types';
import { generateSelectedByStaffAndRooms } from './TimeSlotFiltering/timeslotFiltering';

export const GuestDetailsAndSelections: FC<
  GuestDetailsAndSelectionsPropsConnectedType &
    InjectedFormProps<{}, GuestDetailsAndSelectionsPropsConnectedType> &
    WrappedFieldArrayProps
> = ({
  quantity,
  entity,
  display,
  availableGuests = [],
  selectedGuests,
  loggedInGuest,
  change,
  fields,
  showGenderNeutral,
  meta,
}) => {
  for (let i = 0; i < quantity - fields.length; i += 1) {
    fields.push({ placeholder: true });
  }

  const generatedSelected = generateSelectedByStaffAndRooms(fields.getAll());
  const selected = generatedSelected ? { ...generatedSelected, any: 0 } : null;

  return display ? (
    <>
      {availableGuests.length || loggedInGuest ? (
        <SectionWrapper>
          <AddExistingGuests
            selectedGuests={selectedGuests}
            existingGuests={availableGuests}
            isGenderSpecific={entity.gender}
            minimumGuests={0}
            maximumGuests={fields.length}
            fields={fields}
            guest={loggedInGuest}
          />
        </SectionWrapper>
      ) : null}
      {new Array(quantity).fill({}).map((_, index) => (
        <SectionWrapper key={index}>
          <GuestDetails
            guestIndex={index}
            entity={entity}
            formChange={change}
            fieldPrefix={`guests[${index}]`}
            fields={fields}
            showGenderNeutral={showGenderNeutral}
            selected={selected}
            meta={meta}
          />
        </SectionWrapper>
      ))}
    </>
  ) : null;
};
